import { pushToDataLayer } from './tracking.ts';

type ImboxMessage = [string, ...unknown[]];

declare global {
    interface Window {
        _imbox?: ImboxMessage[];
    }
}

function pushToImbox(message: ImboxMessage) {
    window._imbox = window._imbox || [];

    window._imbox.push(message);
}

const enableImboxTracking = () => {
    pushToImbox([
        'onToggle',
        ({ isOpen }: { isOpen: boolean }) => {
            const event = isOpen ? 'imbox-opened' : 'imbox-closed';

            pushToDataLayer({ event });
        },
    ]);
};

const hashPrefix = '#imbox-form-';

const handleAnchorClick = (event: PointerEvent) => {
    const target = event.target;

    if (target === null) {
        return;
    }

    if (!(target instanceof HTMLAnchorElement)) {
        return;
    }

    if (!target.hash.startsWith(hashPrefix)) {
        return;
    }

    const currentUrl = window.location.href.split('#')[0];
    const anchorUrl = target.href.split('#')[0];

    if (currentUrl !== anchorUrl) {
        return;
    }

    event.preventDefault();

    const formId = target.hash.slice(hashPrefix.length);

    pushToImbox(['openForm', formId]);
};

enableImboxTracking();
document.addEventListener('click', handleAnchorClick);
